export const getBrowserInfo = () => {
  const { userAgent: originalUserAgent } = navigator;

  const userAgent = originalUserAgent.toLowerCase();

  let browser = 'Unknown';
  let version = 'Unknown';

  if (/firefox/i.test(userAgent)) {
    browser = 'Firefox';
    [, version] = userAgent.match(/firefox\/(\d+)/i);
  } else if (/chrome|crios|crmo/i.test(userAgent) && !/edg/i.test(userAgent)) {
    browser = 'Chrome';
    [, version] = userAgent.match(/chrome\/(\d+)/i);
  } else if (/safari/i.test(userAgent) && !/chrome/i.test(userAgent)) {
    browser = 'Safari';
    [, version] = userAgent.match(/version\/(\d+)/i);
  } else if (/edg/i.test(userAgent)) {
    browser = 'Edge';
    [, version] = userAgent.match(/edg\/(\d+)/i);
  } else if (/opr|opera/i.test(userAgent)) {
    browser = 'Opera';
    [, , version] = userAgent.match(/(opera|opr)\/(\d+)/i);
  } else if (/msie|trident/i.test(userAgent)) {
    browser = 'Internet Explorer';
    [, version] = userAgent.match(/(?:msie |rv:)(\d+)/i);
  }

  return version === 'Unknown' ? browser : `${browser} (v${version})`;
};

export const getOSInfo = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  if (/windows nt 11/i.test(userAgent)) {
    return 'Windows 11';
  } if (/windows nt 10/i.test(userAgent)) {
    return 'Windows 8.1';
  } if (/windows nt 6.3/i.test(userAgent)) {
    return 'Windows 8.1';
  } if (/windows nt 6.2/i.test(userAgent)) {
    return 'Windows 8';
  } if (/windows nt 6.1/i.test(userAgent)) {
    return 'Windows 7';
  } if (/windows nt 6.0/i.test(userAgent)) {
    return 'Windows Vista';
  } if (/windows nt 5.1/i.test(userAgent)) {
    return'Windows XP';
  } if (/macintosh|mac os x/i.test(userAgent)) {
    return 'MacOS';
  } if (/android/i.test(userAgent)) {
    return 'Android';
  } if (/iphone|ipad|ipod/i.test(userAgent)) {
    return 'iOS';
  } if (/linux/i.test(userAgent)) {
    return 'Linux';
  }

  return 'Unknown';
};
